import { bindContent, contentCatalog } from "./catalog"
import type { LpcRegistry } from "../lpc/registry"
export let REGISTRATION = contentCatalog.source.sprites.registration
export let SPRITE_DIMENSIONS = contentCatalog.source.sprites.dimensions
export let AUTHORED_WEAPONS = contentCatalog.source.sprites.weapons
export let AUTHORED_CREATURES = contentCatalog.source.sprites.creatures
export let SPRITE_COLORS = contentCatalog.spriteColors
export let SPRITE_REGISTRY: LpcRegistry = contentCatalog.source.registry

// Rebuild the complete table group during preparation; activation only assigns bindings.
bindContent(catalog => ({
    REGISTRATION: catalog.source.sprites.registration,
    SPRITE_DIMENSIONS: catalog.source.sprites.dimensions,
    AUTHORED_WEAPONS: catalog.source.sprites.weapons,
    AUTHORED_CREATURES: catalog.source.sprites.creatures,
    SPRITE_COLORS: catalog.spriteColors,
    SPRITE_REGISTRY: catalog.source.registry,
}), next => {
    REGISTRATION = next.REGISTRATION
    SPRITE_DIMENSIONS = next.SPRITE_DIMENSIONS
    AUTHORED_WEAPONS = next.AUTHORED_WEAPONS
    AUTHORED_CREATURES = next.AUTHORED_CREATURES
    SPRITE_COLORS = next.SPRITE_COLORS
    SPRITE_REGISTRY = next.SPRITE_REGISTRY
})
